import env from '../env';
import { Badge } from 'reactstrap';

const getQuoteBuilderURL = (step, quoteId = '') => {
    if(step && step !== 'QUOTE_SETUP')
        return `/${step.toLowerCase().replaceAll('_','-')}/${quoteId}`;
    return `/quote-setup/${quoteId}`;
}

const QUOTE_STATUS_LABELS = {
    in_progress: 'In Progress',
    sent: 'Sent',
    viewed: 'Viewed',
    initial_acceptance: 'Accepted',
    accepted: 'Signed',
    declined: 'Declined',
    voided: 'Voided',
    archived: 'Archived',
};

const QUOTE_STATUS_COLORS = {
    in_progress: 'warning',
    sent: 'info',
    viewed: 'primary',
    voided: 'secondary',
    initial_acceptance: 'info',
    accepted: 'success',
    declined: 'danger',
    archived: 'danger',
};

const quoteStatusLabel = (status) => QUOTE_STATUS_LABELS[status] ?? '';

const quoteStatusBadge = (status) => {
    const label = quoteStatusLabel(status);
    const color = QUOTE_STATUS_COLORS[status];
    return label ? <Badge color={color}>{label}</Badge> : '';
}

const getQuoteVariables = async (token) => {
    let response = await fetch(`${env.API_URL}/quote-variables/${token}`);
    let result = await response.json();
    return result;
}

const generateUniqueID = () => {
    var ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var ID_LENGTH = 8;
    var uniqueid = '';
    for (var i = 0; i < ID_LENGTH; i++) {
      uniqueid += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
    }

    return uniqueid;
}

const getLogoUrl = (filename) => `${env.API_HOST}/storage/logos/${filename}`;
const getPortraitUrl = (filename) => `${env.API_HOST}/storage/portraits/proposal/${filename}`;
const getProductImageUrl = (filename) => `${env.API_HOST}/storage/product-images/proposal/${filename}`;

const getProposalURL = (quote, preview = true) => {
    const versions = Array.isArray(quote.QuoteVersions) ? quote.QuoteVersions : [];
    const currentVersion = quote.CurrentVersionId && quote.WorkflowStep !== 'SEND_FOR_SIGNING'
        ? versions.find(v => v.VersionId === quote.CurrentVersionId)
        : null;
    const token = (currentVersion ?? versions[0])?.Token ?? quote.Token;
    return `${env.PROPOSAL_BASE_URL}${token}${preview ? '?preview' : ''}`;
};

const capitalizeStr = (s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();

const roundCurrency = (n) => parseFloat(parseFloat(n).toFixed(2));

const formatPrice = (n) => {
    const num = parseFloat(n) || 0;
    const abs = Math.abs(num).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (num < 0 ? '-$' : '$') + abs;
};

const formatTimestamp = (value) => {
    if (!value) return '';
    const d = new Date(value);
    if (isNaN(d)) return value;
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12;
    return `${day}/${month}/${year} ${hours}:${minutes}${ampm}`;
};

const GROUP_COLORS = [
    '#e6194b',
    '#3cb44b',
    '#ffe119',
    '#4363d8',
    '#f58231',
    '#911eb4',
    '#46f0f0',
    '#f032e6',
    '#bcf60c',
    '#fabebe',
    '#008080',
    '#e6beff',
    '#9a6324',
    '#fffac8',
    '#800000',
    '#aaffc3',
    '#808000',
    '#ffd8b1',
    '#000075',
    '#000000'
];

export {
    getQuoteBuilderURL,
    getQuoteVariables,
    quoteStatusLabel,
    quoteStatusBadge,
    generateUniqueID,
    getLogoUrl,
    getPortraitUrl,
    getProductImageUrl,
    getProposalURL,
    capitalizeStr,
    roundCurrency,
    formatPrice,
    formatTimestamp,
    GROUP_COLORS
}
